import type * as API from "../data/api-types";

/** Fixed snooze-duration presets, mirroring the backend's
 * SNOOZE_DURATION_DAYS (recommendations_generation_module/models/alert.py).
 * "Months" are 30/60/90-day windows, not calendar-month arithmetic. */
export const SNOOZE_DURATION_PRESETS: {
  value: NonNullable<API.AlertUpdateRequest["snooze_duration"]>;
  label: string;
}[] = [
  { value: "5d", label: "5 days" },
  { value: "7d", label: "7 days" },
  { value: "14d", label: "14 days" },
  { value: "1m", label: "1 month" },
  { value: "2m", label: "2 months" },
  { value: "3m", label: "3 months" },
];

export const SNOOZE_DURATION_DAYS: Record<
  NonNullable<API.AlertUpdateRequest["snooze_duration"]>,
  number
> = {
  "5d": 5,
  "7d": 7,
  "14d": 14,
  "1m": 30,
  "2m": 60,
  "3m": 90,
};
